import React from 'react'
import FormHome from 'components/FormHome'
import ListCategory from 'components/ListCategory'
import '../styles/home.css'
export default function Home() {
    return (
        <div>
            <FormHome />
            <ListCategory />
        </div>
    )
}
